import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { AppDispatch } from '@/shared/store/store';
import { oauthCallbackRequest } from '@/features/security/sagas/auth-slice';

/**
 * Componente que maneja los tokens OAuth (Google, Facebook, etc.)
 * cuando vienen en la URL después de la autenticación.
 *
 * Este componente debe estar dentro del contexto de <Router>
 * Usa Redux saga para manejar el flujo de autenticación OAuth
 */
const OAuthCallbackHandler: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  // F10/F17 fix Ola 7 — backend ya setea cookies HttpOnly; solo recibimos flag opaco
  // googleAuth=success. Saga llama /me con cookies (withCredentials) para hidratar state.
  // Antes: token/refreshToken/userId venían en URL → server logs + browser history + Referer leak (CWE-598).
  useEffect(() => {
    const googleAuth = searchParams.get('googleAuth');

    if (googleAuth === 'success') {
      // Tokens viven solo en cookies HttpOnly. Payload vacío — saga usa /me API call.
      dispatch(oauthCallbackRequest({
        token: '',
        refreshToken: '',
        userId: ''
      }));

      // Limpiar el flag de la URL
      const currentPath = location.pathname;
      setTimeout(() => {
        navigate(currentPath, { replace: true });
      }, 100);
    }
  }, [searchParams, navigate, location, dispatch]);

  // Este componente no renderiza nada, solo maneja tokens OAuth
  return null;
};

export default OAuthCallbackHandler;
